'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TAGNAMES = {
  'select': 'input',
  'change': 'input',
  'submit': 'form',
  'reset': 'form',
  'error': 'img',
  'load': 'img',
  'abort': 'img'
};

var eventSupport = function eventSupport(eventName) {
  //to support compilation in server-side
  if (typeof window === "undefined" || typeof document === "undefined") return false;
  var el = document.createElement(TAGNAMES[eventName] || 'div');
  eventName = 'on' + eventName;
  var isSupported = (eventName in el);

  if (!isSupported) {
    el.setAttribute(eventName, 'return;');
    isSupported = typeof el[eventName] == 'function';
  }

  el = null;
  return isSupported;
};

exports.default = eventSupport;